import { Injectable } from '@angular/core';

// rxjs
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';

// models

// config
import { environment } from "../../environments/environment";

import { AutoCompleteService } from './auto-complete.service';

@Injectable({
    providedIn: 'root'
})
export class GeocodeService implements AutoCompleteService {

    public locale: string = 'en';

    /**
     * constructor
     *
     * @param jwtHttp
     */
    constructor(
        private http: HttpClient,
    ) { }

    /**
     * Get a list of participants for an event by search attribute
     *
     * @param keyword
     * @returns {Observable<any[]>}
     */
    getResults(keyword: string): Observable<Object> {

        let postParams = {
            search: keyword || ''
        };

        return this.http.post(environment.api + '/geocode/getFilteredList', postParams);
    }

    getItemLabel(item) {
        return item.address;
    }

}
